import { Language } from '../dto/language';
import { QuizStep, QuizMode } from '../dto/user-words';
import type { QuizWord } from '../ui/quizz/use-quizz';
import { IQuizLoader } from '../ui/quiz-loader/i-quiz-loader';

/**
 * Quiz loader service interface
 * Handles loading quiz data from stores
 */
export abstract class IQuizLoaderService {
	/**
	 * Get or create a quiz loader
	 */
	abstract getQuizLoader(
		userId: string | undefined,
		nativeLanguage: Language,
		learnedLanguage: Language,
		quizType: QuizMode,
		contextId?: string,
		wordCount?: number
	): IQuizLoader;

	/**
	 * Convert quiz steps to quiz words format
	 */
	abstract convertQuizStepsToQuizWords(steps: QuizStep[]): QuizWord[];
}




